import React from "react";
import CalendlyEmbed from "../components/Calendly";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const ScheduleCall: React.FC = () => {
  return (
    <div className="container mx-auto py-12">
      <Card className="shadow-lg">
        <CardHeader className="text-center bg-primary text-white rounded-t-lg">
          <CardTitle className="text-2xl font-bold">Schedule a Call</CardTitle>
          <CardDescription className="text-primary-foreground/90">
            Book a time that works for you
          </CardDescription>
        </CardHeader>
        <CardContent className="p-0">
          <CalendlyEmbed
            url="https://calendly.com/anassech132/meet-me"
            height={700}
            className="w-full rounded-b-lg"
            prefill={{
              name: "",
              email: "",
              customAnswers: {
                a1: "Portfolio Website",
              },
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default ScheduleCall;
